//url for local
//export const apiUrl = "http://localhost/duetz.repos/deutzstg-api.azularcdev.com/public";
//export const apiUrl = "http://localhost/deutzstg/deutzapp/public";

//url for stg
//export const apiUrl = "http://deutzstg-api.azularcdev.com";

//url for prod
//export const apiUrl = "http://deutz-angular-four-api.azularcdev.com";
export const apiUrl = "http://deutz-api.deutzusa.com/";



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/config.ts